import { render } from "./VerificationIcon.vue?vue&type=template&id=261ec279"
import script from "./VerificationIcon.vue?vue&type=script&lang=js"
export * from "./VerificationIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__